<template lang="pug">
  div(v-click-outside="close")
    .common-modal(v-if="!completed" :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 営業管理の取引先として登録します
      .common-modal-main
        .common-modal-main-inner
          p
            ErrorMessage(:errors="errors" name="system")

          .add-account-option
            label.checkbox
              input(type='checkbox' v-model="createOpportunity")
              span 案件も同時に作成する

          template(v-if="createOpportunity")
            .add-account
              .add-account-field
                label.add-account-label.required
                  | 案件グループ
                select(v-model="opportunityGroupId" @change="setOpportunityGroup")
                  option(v-for="option in opportunityGroups" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | チャネル
                select(v-model="opportunityChannelId")
                  option(v-for="option in (opportunityGroup ? opportunityGroup.opportunity_channels : [])" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | フェーズ
                select(v-model="opportunityStageId")
                  option(v-for="option in (opportunityGroup ? opportunityGroup.opportunity_stages : [])" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | 商品
                select(v-model="opportunityProductId")
                  option(v-for="option in (opportunityGroup ? opportunityGroup.opportunity_products : [])" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | 確度
                select(v-model="opportunityProbabilityId")
                  option(v-for="option in (opportunityGroup ? opportunityGroup.opportunity_probabilities: [])" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | 担当者
                select(v-model="assignedToId")
                  option(v-for="option in (opportunityGroup ? opportunityGroup.assignable_users: [])" :value="option.id") {{ option.name }}
              .add-account-field
                label.add-account-label.required
                  | 契約予定日
                datepicker(v-model="closeDate" format="yyyy-MM-dd" :language="ja" wrapper-class="hoge")
              .add-account-field
                label.add-account-label.required
                  | 契約金額
                input(type="text" v-model="contractAmount" placeholder="半角数字")
          .add-account
            .add-account-field(style="width: 100%")
              label.add-account-label
                | 検索タグ
              multiselect(
                v-model="searchTags"
                :taggable="true"
                :multiple="true"
                :showNoOptions="false"
                :options="searchTagOptions.filter(i => searchTags.indexOf(i) == -1)"
                @tag="addSearchTag"
                tag-placeholder="新規作成"
                placeholder=""
                select-label="✓"
                selected-label="✓"
                deselect-label="ｘ"
              )

          p.common-modal-button
            input.button-main(type="button", :value="submitting ? '作成しています' : '作成する'" @click="addAccounts" :disabled="!isValid || submitting")
    .common-modal(v-else :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 営業管理に取引先を追加しました
      .common-modal-main
        .common-modal-main-inner
          p
            | 選択されてい事業所を営業管理の取引先に追加しました。
            br
            | 追加された取引先は営業管理からご確認いただけます。
          p.common-modal-button
            a.button-main(target="_blank", @click="goLmt") 営業管理に移動する
    .modal-cover(@click="close")

</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import Datepicker from 'vuejs-datepicker'
  import { ja } from 'vuejs-datepicker/dist/locale'
  import { mapState, mapGetters } from 'vuex'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import moment from 'moment'
  import ErrorMessage from './ErrorMessage'
  import { HumanInfoMessages } from '../../constants'
  import { api } from '../../libs/api'

  export default {
    directives: { ClickOutside },
    props: ['update'],
    data () {
      return {
        ja,
        opportunityGroup: null,
        createOpportunity: true,
        opportunityGroupId: null,
        opportunityChannelId: null,
        opportunityProductId: null,
        opportunityProbabilityId: null,
        opportunityStageId: null,
        assignedToId: null,
        closeDate: this.initialCloseDate(),
        contractAmount: '',
        searchTags: [],
        completed: false,
        submitting: false,
      }
    },
    components: { Datepicker, ErrorMessage, Multiselect },
    mounted () {
      this.popupItem = this.$el
    },
    computed: {
      ...mapState({
        errors: state => state.searchCondition.errors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
        sending: 'account/sending',
        checkedIds: 'account/checkedIds',
        opportunityGroups: 'account/opportunityGroups',
        searchTagOptions: 'account/searchTags',
      }),
      isValid () {
        if (!this.createOpportunity) return true
        if (!!this.opportunityGroupId && !!this.opportunityChannelId &&
          !!this.opportunityProductId && !!this.opportunityProbabilityId &&
          !!this.opportunityStageId && !!this.assignedToId &&
          !!this.closeDate &&
          this.contractAmountValue > 0 && this.contractAmountValue < 1000000000) {
          return true
        }
        return false
      },
      contractAmountValue () {
        return this.contractAmount.replace(/\D/g, '')
      },
    },
    watch: {
      $route () {
        this.$store.commit('account/hideModal')
      },
      contractAmount (value) {
        const formattedValue = value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$nextTick(() => this.contractAmount = formattedValue)
      },
    },
    methods: {
      addSearchTag (newTag) {
        this.searchTags.push(newTag)
      },
      close () {
        this.$store.commit('account/hideModal')
        this.completed = false
        this.createOpportunity = true
        this.opportunityGroup = null
        this.opportunityGroupId = null
        this.closeDate = this.initialCloseDate()
        this.contractAmount = ''
        this.searchTags = []
      },
      initialCloseDate () {
        return moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')
      },
      setOpportunityGroup () {
        this.opportunityGroup = this.opportunityGroups.find(e => e.id === this.opportunityGroupId)
        this.opportunityStageId = this.opportunityGroup.opportunity_stages[0]
          ? this.opportunityGroup.opportunity_stages[0].id
          : null
        this.opportunityProductId = this.opportunityGroup.opportunity_products[0]
          ? this.opportunityGroup.opportunity_products[0].id
          : null
        this.opportunityProbabilityId = this.opportunityGroup.opportunity_probabilities[0]
          ? this.opportunityGroup.opportunity_probabilities[0].id
          : null
        this.opportunityChannelId = this.opportunityGroup.opportunity_channels[0]
          ? this.opportunityGroup.opportunity_channels[0].id
          : null
        this.assignedToId = this.opportunityGroup.assignable_users[0]
          ? this.opportunityGroup.assignable_users[0].id
          : null
      },
      async addAccounts () {
        this.submitting = true
        this.$store.commit('common/lockGlobal')
        try {
          const opportunityParams = this.createOpportunity ? {
            opportunity_group_id: this.opportunityGroupId,
            opportunity_channel_id: this.opportunityChannelId,
            opportunity_product_id: this.opportunityProductId,
            opportunity_probability_id: this.opportunityProbabilityId,
            opportunity_stage_id: this.opportunityStageId,
            assigned_to_id: this.assignedToId,
            close_date: this.closeDate,
            contract_amount: this.contractAmountValue,
          } : null

          const result = await api.addAccounts(
            this.checkedIds,
            { search_tags: this.searchTags },
            opportunityParams,
          )
          this.update(result.map(company => company.company_id))

          this.$store.dispatch('common/pushToastInfo', {
            info: HumanInfoMessages.ADD_ACCOUNT_TO_LMT,
          })
          this.completed = true
          this.opportunityGroup = null
        } catch (e) {
          this.$store.dispatch('common/pushToastError', {
            error: e[0],
          })
        } finally {
          this.$store.commit('common/unlockGlobal')
          this.submitting = false
        }
      },
      goLmt () {
        this.close()
        const url = location.origin.match(/kobot/)
          ? location.origin.replace('kobot', 'lmt-kobot')
          : location.origin.replace('app', 'lmt')
        window.open(url, '_blank')
      },
    },
  }
</script>

<style scoped>
.add-account >>> .multiselect__tags {
  min-height: 35px;
  border-radius: 4px;
  border: 1px solid #ced4da;
}
.add-account >>> .multiselect__select {
  display: none;
}
.add-account >>> .multiselect__input {
  border: none !important;
  padding: 0px !important;
}
.add-account >>> .multiselect__tag {
  background: #828282;
}
.add-account >>> .multiselect__tag-icon:after {
  color: #fff;
}
.add-account >>> .multiselect__tag-icon:hover {
  background: #828282;
}
.add-account >>> .multiselect__option {
  min-height: 25px;
  line-height: 16px;
  padding: 6px 12px;
}

.add-account >>> .multiselect__option--highlight {
  background: #828282;
}

.add-account >>> .multiselect__option--highlight:after {
  line-height: 25px;
  background: #828282;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/AddAccountModal.vue